import { AddressType } from "../../types";
import { Action } from "../../types/redux";

export enum USER_ADDRESS_ACTION_ENUM {
  SET_USER_ADDRESSES = "set_user_addresses",
  REMOVE_ONE_TIME_USED_ADDRESS = "remove_one_time_used_address",
  RESET_STATE = "reset_state",
}

export type UserAddressPayload = {
  shippingAddresses: AddressType[];
  billingAddresses: AddressType[];
};

const initialState = {
  shippingAddresses: [] as AddressType[],
  billingAddresses: [] as AddressType[],
  isUserAddressLoading: false,
  isUserAddressLoaded: false,
};

const reducer = (
  state = initialState,
  action: Action<USER_ADDRESS_ACTION_ENUM, UserAddressPayload>
) => {
  switch (action.type) {
    case USER_ADDRESS_ACTION_ENUM.SET_USER_ADDRESSES:
      return {
        ...state,
        shippingAddresses: action.payload.shippingAddresses,
        billingAddresses: action.payload.billingAddresses,
        isUserAddressLoaded: true,
        isUserAddressLoading: false,
      };
    case USER_ADDRESS_ACTION_ENUM.REMOVE_ONE_TIME_USED_ADDRESS:
      return {
        ...state,
        shippingAddresses: action.payload.shippingAddresses,
        billingAddresses: action.payload.billingAddresses,
      };
    case USER_ADDRESS_ACTION_ENUM.RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
